import React from "react";
import "./progress-loader-with-text.scss";

interface ProgressLoaderWithTextProps {
  progress: number;
  text?: string;
}

export function ProgressLoaderWithText(props: ProgressLoaderWithTextProps) {
  const { progress, text } = props;

  return (
    <div className="progress-loader-with-text">
      <div className="progress-container">
        <div className="progress-bar" style={{ width: `${progress}%` }}></div>
      </div>
      {text && <div className="progress-text">{text}</div>}
    </div>
  );
}
